<script setup>
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import ArrowDownIcon from "./ArrowDownIcon.vue";
import { europe, latin, asia, north, south } from "../../../constants";
import MobileMenuItem from "./MobileMenuItem.vue";

const props = defineProps({
  labelClass: {
    type: String,
    default: "",
  },
});
</script>

<template>
  <Popover v-slot="{ open }" class="relative">
    <PopoverButton
      class="inline-flex items-center gap-x-2 font-montserrat non-italic font-bold leading-10 text-indigo-base text-15p outline-none focus:ring-0"
      :class="props.labelClass"
    >
      Destinations
      <ArrowDownIcon
        custom-class="w-5 h-3"
        :class="{ 'rotate-180 transform': open }"
        aria-hidden="true"
      />
    </PopoverButton>

    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="opacity-0 -translate-y-1"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition ease-in duration-150"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 -translate-y-1"
    >
      <PopoverPanel class="font-montserrat">
        <div class="max-w-2xl">
          <div class="block md:grid grid-cols-2 gap-x-6 sm:gap-x-8">
            <div class="px-6">
              <MobileMenuItem label="Asia / Middle East" :options="asia" />
              <MobileMenuItem label="Latin America" :options="latin" />
              <MobileMenuItem label="North America" :options="north" />
              <MobileMenuItem label="Europe" :options="europe" />
              <MobileMenuItem label="South Pacific" :options="south" />
            </div>
          </div>
        </div>
      </PopoverPanel>
    </transition>
  </Popover>
</template>
